// Like up-expand, but will follow the link as a browser action.
// Intended for download links, where you do not want Unpoly to handle the link.
up.compiler('[click-link-inside]', (element) => {

  element.addEventListener('click', (event) => {
    const linkInside = element.querySelector('a')
    const clickedLink = event.target.closest('a')

    if (linkInside && (!clickedLink || linkInside !== clickedLink)) {
      up.event.halt(event)
      linkInside.click()
    }
  })

})
